import { ProntuarioRetinologoData } from '../interfaces/prontuarioRetinologo.interface'

export type ProntuarioRetinologoFormData = ProntuarioRetinologoData

export const getInitialData = (
  initialData?: Partial<ProntuarioRetinologoData>
): ProntuarioRetinologoFormData => {
  // Tratar dataInicioSintomas: converter Date para string no formato YYYY-MM-DD
  let dataInicioSintomas = ''
  if (initialData?.dataInicioSintomas) {
    if (typeof initialData.dataInicioSintomas === 'string') {
      dataInicioSintomas = initialData.dataInicioSintomas
    } else if (initialData.dataInicioSintomas instanceof Date) {
      dataInicioSintomas = initialData.dataInicioSintomas.toISOString().split('T')[0]
    }
  }

  return {
    id_paciente: initialData?.id_paciente ?? 0,
    // Motivo da consulta
    motivoConsulta: initialData?.motivoConsulta ?? '',
    // História da Doença Atual
    dataInicioSintomas: dataInicioSintomas,
    naturezaSintomas: initialData?.naturezaSintomas ?? '',
    perdaVisual: initialData?.perdaVisual ?? false,
    visaoBorrada: initialData?.visaoBorrada ?? false,
    fotopsias: initialData?.fotopsias ?? '',
    moscasVolantes: initialData?.moscasVolantes ?? '',
    dorOcular: initialData?.dorOcular ?? '',
    evolucaoDuracao: initialData?.evolucaoDuracao ?? '',
    fatoresAgravamOuAliviam: initialData?.fatoresAgravamOuAliviam ?? '',
    // História médica e Pregressa Ocular
    diabetes: initialData?.diabetes ?? false,
    hipertensao: initialData?.hipertensao ?? false,
    medicamentosUsoContinuo: initialData?.medicamentosUsoContinuo ?? '',
    cirurgiasOcularesPrevias: initialData?.cirurgiasOcularesPrevias ?? '',
    usoLentesCorretivas: initialData?.usoLentesCorretivas ?? false,
    grauLentes: initialData?.grauLentes ?? '',
    examesRetinaAnteriores: initialData?.examesRetinaAnteriores ?? '',
    // Exame Físico/Oftalmológico
    acuidadeVisualOdComCorrecao: initialData?.acuidadeVisualOdComCorrecao ?? '',
    acuidadeVisualOdSemCorrecao: initialData?.acuidadeVisualOdSemCorrecao ?? '',
    acuidadeVisualOeComCorrecao: initialData?.acuidadeVisualOeComCorrecao ?? '',
    acuidadeVisualOeSemCorrecao: initialData?.acuidadeVisualOeSemCorrecao ?? '',
    pressaoIntraocularOd: initialData?.pressaoIntraocularOd ?? '',
    pressaoIntraocularOe: initialData?.pressaoIntraocularOe ?? '',
    achadosFundoOlho: initialData?.achadosFundoOlho ?? '',
    outrosExamesRealizados: initialData?.outrosExamesRealizados ?? [],
    // Plano Terapêutico e Conduta
    tratamentoIndicado: initialData?.tratamentoIndicado ?? '',
    examesNecessarios: initialData?.examesNecessarios ?? [],
    retornoSeguimento: initialData?.retornoSeguimento ?? '',
    status_atendimento: initialData?.status_atendimento ?? ''
  }
}
